<template>
  <div class="">
    <!-- 消费流水 -->
    <el-card class="box-card">
      <div class="search-form" style="text-align: left">
        <el-form ref="searchForm" :inline="true" size="small" :model="searchForm" label-width="50px" label-position="left"
          class="demo-form-inline">
          <el-form-item :label="$t('finance.consumption.time')">
            <el-date-picker
              style="width:320px;"
              v-model="searchForm.createtime"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:ss"
              :range-separator="$t('finance.consumption.to')"
              :start-placeholder="$t('finance.consumption.startDate')"
              :end-placeholder="$t('finance.consumption.endDate')">
            </el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('finance.consumption.type')">
            <el-select v-model="searchForm.type" :placeholder="$t('finance.consumption.placeholder.selectType')">
              <el-option :label="$t('finance.consumption.typeOptions.adminRecharge')" :value="0"></el-option>
              <el-option :label="$t('finance.consumption.typeOptions.recharge')" :value="1"></el-option>
              <el-option :label="$t('finance.consumption.typeOptions.consumption')" :value="2"></el-option>
              <el-option :label="$t('finance.consumption.typeOptions.freightDeduction')" :value="3"></el-option>
              <el-option :label="$t('finance.consumption.typeOptions.refund')" :value="4"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-search" type="primary" size="small" @click="handleSearch">{{ $t('finance.consumption.button.query') }}</el-button>
            <el-button icon="el-icon-refresh-right" type="primary" size="small" @click="resetSearch">{{ $t('finance.consumption.button.reset') }}</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="" style="margin-bottom: 15px;text-align:left">
        <el-button type="primary" icon="el-icon-download" size="small" @click="handleExport">{{ $t('finance.consumption.button.export') }}</el-button>
      </div>
      <el-table :data="dataList" border size="small" height="600">
        <el-table-column type="index" :index="indexMethod" :label="$t('finance.consumption.serialNumber')" width="60"></el-table-column>
        <el-table-column prop="createtime" :label="$t('finance.consumption.time')" show-overflow-tooltip></el-table-column>
        <el-table-column prop="money" :label="$t('finance.consumption.amount')" :formatter="formatMoney" show-overflow-tooltip></el-table-column>
        <el-table-column prop="after" :label="$t('finance.consumption.currentBalance')" :formatter="formatMoney" show-overflow-tooltip></el-table-column>
        <el-table-column prop="type" :label="$t('finance.consumption.type')" :formatter="formatType" show-overflow-tooltip></el-table-column>
        <el-table-column prop="platform_order_sn" :label="$t('finance.consumption.logisticsNo')" show-overflow-tooltip></el-table-column>
        <el-table-column prop="porder_sn" :label="$t('finance.consumption.deductionOrderNo')" show-overflow-tooltip></el-table-column>
        <el-table-column prop="memo" :label="$t('finance.consumption.remark')" :formatter="formatMemo" show-overflow-tooltip></el-table-column>
        <el-table-column prop="remark" :label="$t('finance.consumption.deductionNote')" show-overflow-tooltip></el-table-column>
      </el-table>
      <div class="pagization-box">
        <CustomPagization
          :background="true"
          :currentPage="current"
          :total="total"
          :pageSize="size"
          @current-change="currentChange"
        />
      </div>
    </el-card>
  </div>
</template>

<script>
import { consumptionList, consumptionExport } from '@/api/finance'
import { downloadBase64AsExcel } from "@/common/common.js"
export default {
  data() {
    return {
      searchForm: {},
      current: 1,
      size: 20,
      total: 1,
      dataList: [],
    };
  },
  mounted(){
    this.getConsumptionList()
  },
  methods: {
    // 英文模式下将后端中文枚举与备注映射为用户可读文案
    formatType(row, column, value) {
      if (this.$i18n.locale !== 'en') return value
      const types = ['管理员充值', '充值', '消费', '补扣运费', '退款']
      const keys = ['adminRecharge', 'recharge', 'consumption', 'freightDeduction', 'refund']
      const index = types.indexOf(value)
      return index > -1 ? this.$t(`finance.consumption.typeOptions.${keys[index]}`) : value
    },
    formatMemo(row, column, value) {
      return this.$i18n.locale === 'en' && value === '打单消费'
        ? this.$t('finance.consumption.shippingCharge')
        : value
    },
    formatMoney(row, column, value) {
      const amount = Number(value)
      return Number.isFinite(amount)
        ? '$' + amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        : value
    },
      // 导出数据
      handleExport(){
        consumptionExport({
          user_code:JSON.parse(window.localStorage.getItem("userInfo1")).user_code,
          ...this.searchForm
        }).then(res => {
          downloadBase64AsExcel(res.data.file,res.data.name)
        })
      },
    // 获取列表
    getConsumptionList(){
      let queryForm = {}
      if(this.searchForm.createtime){
        queryForm = {
          ...this.searchForm,
          createtime: this.searchForm.createtime.join("/")
        }
      }else{
        queryForm = {
          ...this.searchForm
        }
      }
      consumptionList({
        user_code:JSON.parse(window.localStorage.getItem("userInfo1")).user_code,
        page: this.current,
        limit: this.size,
        ...queryForm
      }).then(res => {
        if(res.code == 1){
          this.dataList = []
          this.dataList = res.data.list
          this.total = res.data.total
        }
      })
    },
    // table首列序号
    indexMethod(index) {
      return (this.current - 1) * this.size + index + 1;
    },
    // 页数变化
    currentChange(current) {
      this.current = current;
      this.getConsumptionList();
    },
    // 重置筛选
    resetSearch() {
      this.$refs["searchForm"].resetFields();
      this.searchForm = {}
      this.value1 = []
      this.current = 1;
      this.total = 1;
      this.dataList = [];
      this.handleSearch();
    },
    // 去筛选
    handleSearch() {
      this.current = 1;
      this.total = 1;
      this.dataList = [];
      this.getConsumptionList();
    },
  },
};
</script>
<style lang="scss" scoped>
.pagization-box {
  overflow: hidden;
  margin-top: 10px;

  .el-pagination {
    float: right;
  }
}
/deep/ {
  .el-table {
    thead {
      color: #fff;
      font-weight: 500;
      background: #F5F7FA;
      color: #606266;
      & th {
        background-color: transparent;
      }
      & tr {
        background-color: transparent;
      }
    }
  }
}
</style>
